import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Waitlist from "./pages/Waitlist";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Home />}
        />

        <Route
          path="/waitlist"
          element={<Waitlist />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;